/* STYRKR FUEL TOOL — DATA LAYER
   Citations, product catalog, plan generator algorithm.
   See RESEARCH_NOTES.md for the science backbone.
   Namespace: window.STYRKR_FUEL_DATA — read-only. */

(function (window) {
  'use strict';

  /* ─────────────────────────────────────────────
     CITATIONS — mirror of RESEARCH_NOTES.md
  ───────────────────────────────────────────── */
  const CITATIONS = {
    1: {
      authors: 'Jeukendrup, A.E.',
      year: 2014,
      title: 'A step towards personalized sports nutrition: carbohydrate intake during exercise',
      journal: 'Sports Medicine',
      vol: '44(Suppl 1)',
      pages: 'S25–S33',
      tag: 'Carb tier ladder',
      url: 'https://doi.org/10.1007/s40279-014-0148-z'
    },
    2: {
      authors: 'O\u2019Brien, W.J. & Rowlands, D.S.',
      year: 2011,
      title: 'Fructose-maltodextrin ratio in a carbohydrate-electrolyte solution differentially affects exogenous carbohydrate oxidation rate, gut comfort, and performance',
      journal: 'Am J Physiol Gastrointest Liver Physiol',
      vol: '300(1)',
      pages: 'G181–G189',
      tag: 'Dual-carb 1:0.8 ratio',
      url: 'https://doi.org/10.1152/ajpgi.00419.2010'
    },
    3: {
      authors: 'Costa, R.J.S. et al.',
      year: 2017,
      title: 'Systematic review: exercise-induced gastrointestinal syndrome',
      journal: 'Aliment Pharmacol Ther',
      vol: '46(3)',
      pages: '246–265',
      tag: 'Gut training adaptation',
      url: 'https://doi.org/10.1111/apt.14157'
    },
    4: {
      authors: 'Sawka, M.N. et al.',
      year: 2007,
      title: 'ACSM Position Stand: Exercise and fluid replacement',
      journal: 'Med Sci Sports Exerc',
      vol: '39(2)',
      pages: '377–390',
      tag: 'Sweat rate & fluid',
      url: 'https://doi.org/10.1249/mss.0b013e31802ca597'
    },
    5: {
      authors: 'Baker, L.B.',
      year: 2019,
      title: 'Sweating rate and sweat sodium concentration in athletes',
      journal: 'Sports Medicine',
      vol: '49(Suppl 1)',
      pages: 'S111–S128',
      tag: 'Sodium tiers',
      url: 'https://doi.org/10.1007/s40279-019-01044-6'
    },
    6: {
      authors: 'Guest, N.S. et al.',
      year: 2021,
      title: 'ISSN position stand: caffeine and exercise performance',
      journal: 'J Int Soc Sports Nutr',
      vol: '18(1)',
      pages: '1',
      tag: 'Caffeine dosing',
      url: 'https://doi.org/10.1186/s12970-020-00383-4'
    },
    7: {
      authors: 'Maughan, R.J. et al.',
      year: 2018,
      title: 'IOC Consensus Statement: Dietary supplements and the high-performance athlete',
      journal: 'Br J Sports Med',
      vol: '52(7)',
      pages: '439–455',
      tag: 'Race-day consensus',
      url: 'https://doi.org/10.1136/bjsports-2018-099027'
    },
    8: {
      authors: 'Stellingwerff, T. & Cox, G.R.',
      year: 2014,
      title: 'Systematic review: carbohydrate supplementation on exercise performance',
      journal: 'Appl Physiol Nutr Metab',
      vol: '39(9)',
      pages: '998–1011',
      tag: 'Solid food in endurance',
      url: 'https://doi.org/10.1139/apnm-2014-0027'
    },
    9: {
      authors: 'Burke, L.M. & Hawley, J.A.',
      year: 2018,
      title: 'Swifter, higher, stronger: What\u2019s on the menu?',
      journal: 'Science',
      vol: '362(6416)',
      pages: '781–787',
      tag: 'Goal periodisation',
      url: 'https://doi.org/10.1126/science.aau2093'
    },
    10: {
      authors: 'Hew-Butler, T. et al.',
      year: 2015,
      title: 'Third International Exercise-Associated Hyponatremia Consensus Statement',
      journal: 'Clin J Sport Med',
      vol: '25(4)',
      pages: '303–320',
      tag: 'Hyponatraemia risk',
      url: 'https://doi.org/10.1097/JSM.0000000000000221'
    }
  };

  /* ─────────────────────────────────────────────
     PRODUCT CATALOG — live Shopify variant IDs
     Pulled 2026-04-28 from styrkr.myshopify.com
     TODO: swap GEL30 Caffeine → GEL50 Caffeine when SKU launches.
  ───────────────────────────────────────────── */
  const PRODUCTS = {
    GEL50_BERRY: {
      key: 'GEL50_BERRY',
      family: 'GEL50',
      title: 'GEL50 Dual-Carb Energy Gel — Mixed Berry',
      shortTitle: 'GEL50 Berry',
      handle: 'gel50-dual-carb-energy-gel-citrus-fruits',
      productId: 15740727132542,
      variantId: 56791863132542,
      price: 29.99,
      packSize: 12,
      packLabel: 'Box of 12',
      perUnit: { carbsG: 50, fluidMl: 0, sodiumMg: 100, caffeineMg: 0 },
      caffeinated: false,
      role: 'gel-carb',
      veganFriendly: true
    },
    GEL50_CITRUS: {
      key: 'GEL50_CITRUS',
      family: 'GEL50',
      title: 'GEL50 Dual-Carb Energy Gel — Citrus',
      shortTitle: 'GEL50 Citrus',
      handle: 'gel50-dual-carb-energy-gel-citrus-fruits',
      productId: 15740727132542,
      variantId: 56791862215038,
      price: 29.99,
      packSize: 12,
      packLabel: 'Box of 12',
      perUnit: { carbsG: 50, fluidMl: 0, sodiumMg: 100, caffeineMg: 0 },
      caffeinated: false,
      role: 'gel-carb',
      veganFriendly: true
    },
    GEL30_CAF: {
      key: 'GEL30_CAF',
      family: 'GEL30_CAF',
      title: 'GEL30 Caffeine Energy Gel',
      shortTitle: 'GEL30 Caf',
      handle: 'gel30-dual-carb-gel-caffeine',
      productId: 6841530613794,
      variantId: 39841646903330,
      price: 24.99,
      packSize: 12,
      packLabel: 'Box of 12',
      perUnit: { carbsG: 30, fluidMl: 0, sodiumMg: 50, caffeineMg: 75 },
      caffeinated: true,
      role: 'gel-caf',
      veganFriendly: true
    },
    BAR50_VARIETY: {
      key: 'BAR50_VARIETY',
      family: 'BAR50',
      title: 'BAR50 Energy Rice Bars — Variety',
      shortTitle: 'BAR50 Variety',
      handle: 'bar50-variety-pack-energy-bars',
      productId: 15740681716094,
      variantId: 56791600628094,
      price: 29.99,
      packSize: 12,
      packLabel: 'Box of 12',
      perUnit: { carbsG: 50, fluidMl: 0, sodiumMg: 75, caffeineMg: 0 },
      caffeinated: false,
      role: 'bar-solid',
      veganFriendly: true
    },
    MIX60: {
      key: 'MIX60',
      family: 'MIX60',
      title: 'MIX60 Dual-Carb Energy Drink Mix',
      shortTitle: 'MIX60',
      handle: 'mix60-dual-carb-drink',
      productId: 6841476579362,
      variantId: 39845870403618,
      price: 24.99,
      packSize: 12,
      packLabel: 'Box of 12',
      perUnit: { carbsG: 60, fluidMl: 500, sodiumMg: 250, caffeineMg: 0 },
      caffeinated: false,
      role: 'drink-base',
      veganFriendly: true
    },
    MIX90: {
      key: 'MIX90',
      family: 'MIX90',
      title: 'MIX90 Dual-Carb Energy Drink Mix',
      shortTitle: 'MIX90',
      handle: 'mix90-dual-carb-drink',
      productId: 6841441746978,
      variantId: 39845876006946,
      price: 29.99,
      packSize: 12,
      packLabel: 'Box of 12',
      perUnit: { carbsG: 90, fluidMl: 700, sodiumMg: 350, caffeineMg: 0 },
      caffeinated: false,
      role: 'drink-high',
      veganFriendly: true
    },
    MIX90_CAF: {
      key: 'MIX90_CAF',
      family: 'MIX90_CAF',
      title: 'MIX90 Caffeine Dual-Carb Energy Drink Mix',
      shortTitle: 'MIX90 Caf',
      handle: 'mix90-caffeine-dual-carb-drink',
      productId: 6841441746978,
      variantId: 39845875646498,
      price: 34.99,
      packSize: 12,
      packLabel: 'Box of 12',
      perUnit: { carbsG: 90, fluidMl: 700, sodiumMg: 350, caffeineMg: 100 },
      caffeinated: true,
      role: 'drink-high-caf',
      veganFriendly: true
    },
    SLT_PLUS: {
      key: 'SLT_PLUS',
      family: 'SLT+',
      title: 'SLT+ High-Strength Electrolyte — Variety',
      shortTitle: 'SLT+',
      handle: 'slt-plus',
      productId: 15363667689854,
      variantId: 55988528480638,
      price: 29.99,
      packSize: 30,
      packLabel: '30 servings',
      perUnit: { carbsG: 0, fluidMl: 500, sodiumMg: 1000, caffeineMg: 0 },
      caffeinated: false,
      role: 'electrolyte',
      veganFriendly: true
    }
  };

  /* ─────────────────────────────────────────────
     SPORT / DISCIPLINE PROFILES
  ───────────────────────────────────────────── */
  const DISCIPLINES = {
    road_run:    { label: 'Road Running',    icon: 'run',     fluidFactor: 1.00, solidFoodOk: false, hardLogistics: false },
    trail_run:   { label: 'Trail Running',   icon: 'trail',   fluidFactor: 0.90, solidFoodOk: true,  hardLogistics: true  },
    road_cycle:  { label: 'Road Cycling',    icon: 'bike',    fluidFactor: 1.05, solidFoodOk: true,  hardLogistics: false },
    offroad_cyc: { label: 'Off-Road / MTB',  icon: 'mtb',     fluidFactor: 0.95, solidFoodOk: true,  hardLogistics: true  },
    triathlon:   { label: 'Triathlon',       icon: 'tri',     fluidFactor: 1.00, solidFoodOk: false, hardLogistics: true  },
    ultra:       { label: 'Ultra Running',   icon: 'ultra',   fluidFactor: 0.85, solidFoodOk: true,  hardLogistics: true  }
  };

  const INTENSITY = {
    easy:      { label: 'Easy',      carbMult: 0.75, fluidMult: 0.80, effortPct: 60 },
    steady:    { label: 'Steady',    carbMult: 1.00, fluidMult: 1.00, effortPct: 75 },
    threshold: { label: 'Threshold', carbMult: 1.05, fluidMult: 1.10, effortPct: 90 },
    race:      { label: 'Race-pace', carbMult: 1.00, fluidMult: 1.10, effortPct: 95 }
  };

  const GUT_TIERS = {
    new:         { label: 'New to fueling',   target: 60,  cite: 3 },
    experienced: { label: 'Experienced',      target: 90,  cite: 1 },
    trained:     { label: 'High-carb trained', target: 120, cite: 1 }
  };

  const SODIUM_TIERS = {
    light:    { label: 'Light',      mgPerL: 600,  cite: 5 },
    average:  { label: 'Average',    mgPerL: 700,  cite: 5 },
    salty:    { label: 'Salty',      mgPerL: 1000, cite: 5 },
    very:     { label: 'Very salty', mgPerL: 1300, cite: 5 }
  };

  /* ─────────────────────────────────────────────
     PLAN GENERATOR
     Input → personalised fueling plan
  ───────────────────────────────────────────── */
  function generatePlan(input) {
    const i = Object.assign({
      sport: 'road_cycle',
      durationMin: 240,
      intensity: 'steady',
      weightKg: 75,
      caffeine: 'half',          // 'yes' | 'half' | 'no'
      weighting: 'balanced',     // 'gels' | 'drinks' | 'food' | 'balanced'
      gutTier: 'experienced',    // 'new' | 'experienced' | 'trained'
      sweatRateMlH: null,        // ml/h, optional
      sodiumTier: 'average',     // 'light' | 'average' | 'salty' | 'very'
      ftpW: null,                // cyclists, optional
      thresholdPaceMinKm: null,  // runners, optional
      goal: 'pb',                // 'finish' | 'pb' | 'podium' | 'adapt'
      dietary: 'standard',       // 'standard' | 'vegan'
      flavour: 'berry'           // 'berry' | 'citrus' (GEL50 flavour pref)
    }, input || {});

    const sport = DISCIPLINES[i.sport] || DISCIPLINES.road_cycle;
    const intensity = INTENSITY[i.intensity] || INTENSITY.steady;
    const gut = GUT_TIERS[i.gutTier] || GUT_TIERS.experienced;
    const sodTier = SODIUM_TIERS[i.sodiumTier] || SODIUM_TIERS.average;
    const durHrs = i.durationMin / 60;

    /* TARGETS ─────────────────────────────────── */
    // Carb target: gut tier × intensity multiplier (capped at gut tier ceiling)
    const carbTargetGH = Math.min(
      Math.round(gut.target * intensity.carbMult),
      gut.target
    );

    // Fluid target: from sweat rate or estimated
    let sweatRate = i.sweatRateMlH;
    if (!sweatRate) {
      // Estimate: ~10 ml/kg/h baseline × intensity factor × discipline factor
      sweatRate = Math.round(10 * i.weightKg * intensity.fluidMult * sport.fluidFactor);
    }
    const fluidTargetMlH = Math.round(sweatRate * 0.70 * sport.fluidFactor);

    // Sodium target: sweat rate × sweat sodium concentration × replacement factor
    const sodiumTargetMgH = Math.round((sweatRate / 1000) * sodTier.mgPerL * 0.70);

    // Caffeine total cap: 4 mg/kg for half-and-half, 5 mg/kg for full caf
    const cafCapMg = i.caffeine === 'no' ? 0
                   : i.caffeine === 'half' ? Math.round(4 * i.weightKg)
                   : Math.round(5 * i.weightKg);

    /* TIMELINE ────────────────────────────────── */
    // Two-phase algorithm:
    //   Phase 1 — Place events using per-hour budget (never exceed gut.target g/h)
    //   Phase 2 — Top up sodium with SLT+ where the gap remains
    // Race mode also gets a pre-race fueling slot at -15 min.

    const isRace = i.sessionType === 'race_day' || i.sessionType === 'race_prep';
    const preStartMin = isRace ? -30 : 0;     // axis floor for charts/timeline
    const weighting = i.weighting;

    // Decide MIX choice based on caffeine pref + carb target
    // 'gels' weighting prefers MIX60 so gels can fill the per-hour budget.
    // 'food' weighting prefers MIX60 so bars also fit under the gut ceiling.
    // Otherwise: MIX90 if target ≥ 75 g/h, MIX60 below.
    const useMix90 = (carbTargetGH >= 75 || weighting === 'drinks')
                     && weighting !== 'gels' && weighting !== 'food';
    const mixSku = i.caffeine === 'yes' && useMix90 ? PRODUCTS.MIX90_CAF
                 : useMix90 ? PRODUCTS.MIX90
                 : PRODUCTS.MIX60;
    const gelMain = i.flavour === 'citrus' ? PRODUCTS.GEL50_CITRUS : PRODUCTS.GEL50_BERRY;
    const gelCaf = PRODUCTS.GEL30_CAF;

    // Weighting profile defines product mix ratios
    const profile = (function () {
      // mixPerH = bottles per hour. gelPerH/barPerH = events per hour.
      // 'gels' uses LESS MIX so the per-hour budget has room for gels (MIX90 alone caps at gut tier).
      // 'food' uses MIX every other hour so bars fit even at the 60 g/h gut ceiling.
      if (weighting === 'gels')    return { mixPerH: 0.5, gelPerH: 1.8, barPerH: 0.0 };
      if (weighting === 'drinks')  return { mixPerH: 1.0, gelPerH: 0.4, barPerH: 0.0 };
      if (weighting === 'food')    return { mixPerH: 0.5, gelPerH: 0.4, barPerH: 0.5 };
      return                            { mixPerH: 0.8, gelPerH: 1.0, barPerH: sport.solidFoodOk && durHrs > 2 ? 0.3 : 0 };
    })();

    // Generate events
    const events = [];
    let totalCarbs = 0, totalFluid = 0, totalSodium = 0, totalCaffeine = 0;
    let gelToggle = 0;

    function pushEvent(ev) {
      events.push(ev);
      totalCarbs += ev.carbs || 0;
      totalFluid += ev.fluid || 0;
      totalSodium += ev.sodium || 0;
      totalCaffeine += ev.caffeine || 0;
    }
    // Budget-aware gel picker: respects caffeine preference AND remaining hour budget.
    // Returns null if no gel fits the budget — caller must break out of its loop.
    function pickGel(remainingBudget) {
      const carbsCaf  = gelCaf.perUnit.carbsG;
      const carbsMain = gelMain.perUnit.carbsG;
      const cafCapOk  = totalCaffeine + gelCaf.perUnit.caffeineMg <= cafCapMg;
      const cafFits   = carbsCaf <= remainingBudget && cafCapOk;
      const mainFits  = carbsMain <= remainingBudget;

      if (!cafFits && !mainFits) return null;

      if (i.caffeine === 'no')  return mainFits ? gelMain : null;
      if (i.caffeine === 'yes') return cafFits ? gelCaf : (mainFits ? gelMain : null);

      // half-and-half: alternate, with budget-aware fallback
      const wantCaf = gelToggle % 2 === 0;
      if (wantCaf && cafFits)   { gelToggle++; return gelCaf; }
      if (!wantCaf && mainFits) { gelToggle++; return gelMain; }
      // First choice doesn't fit — try the other
      if (cafFits)  { gelToggle++; return gelCaf; }
      if (mainFits) { gelToggle++; return gelMain; }
      return null;
    }

    // ── 0. PRE-RACE (race mode + meaningful duration only) ──
    // 30 min pre-start: ~50g carb top-up to peak liver glycogen at gun [7]
    // Conditional: skip on short easy efforts (Burke 2018 — pre-race carb top-up
    // matters for events >90 min at moderate-high intensity).
    // For sub-60 min sessions OR easy <90 min OR new gut tier <90 min, skip pre.
    // For new gut tier 90–120 min, scale to GEL30 (lighter bolus) when caf available;
    // otherwise keep GEL50.
    const preRaceJustified = isRace && !(
      i.durationMin < 60
      || (i.durationMin < 90 && i.intensity === 'easy')
      || (i.durationMin < 90 && i.gutTier === 'new')
    );
    if (preRaceJustified) {
      // Lighter pre-race for beginners / shorter sessions
      const wantsLightPre = i.gutTier === 'new' || i.durationMin < 120;
      const preGel = wantsLightPre && i.caffeine !== 'no' ? PRODUCTS.GEL30_CAF
                   : i.flavour === 'citrus' ? PRODUCTS.GEL50_CITRUS
                   : PRODUCTS.GEL50_BERRY;
      pushEvent({
        timeMin: -30,
        product: preGel,
        qty: 1,
        carbs: preGel.perUnit.carbsG,
        fluid: 0,
        sodium: preGel.perUnit.sodiumMg,
        caffeine: preGel.perUnit.caffeineMg,
        label: 'Pre-race fuel',
        phase: 'pre'
      });
    }

    // ── 1. PER-HOUR BUDGET WALK ──
    // Each hour gets up to gut.target g/h. MIX seeds the hour, gels top up to soft target.
    const hours = Math.ceil(durHrs);
    const gutCeiling = gut.target;             // hard ceiling per hour
    const hourSoftTarget = carbTargetGH;       // soft target per hour
    const mixSpacingHrs = profile.mixPerH > 0 ? Math.max(1, 1 / profile.mixPerH) : 99;

    // BAR cadence (only solid-food-friendly disciplines, >2h)
    const barEnabled = sport.solidFoodOk && durHrs > 2 && profile.barPerH > 0;
    let nextBarAtMin = barEnabled ? 90 : Infinity;     // first BAR at 1:30 if enabled

    // Triathlon swim guard — no fueling possible during the swim leg.
    // Conservative estimate: swim takes ~12% of total race time across distances
    // (sprint ~10%, Olympic ~14%, 70.3 ~12%, IM ~10%). We skip any in-race events
    // before this minute marker. Drinks-led/all weighting still places a bottle
    // at T1 (swim→bike) which is when bottle access begins.
    const swimGuardMin = i.sport === 'triathlon' ? Math.round(i.durationMin * 0.12) : 0;
    const t1MinForTri = swimGuardMin;     // alias used to align first MIX with T1

    for (let h = 0; h < hours; h++) {
      const hourStart = h * 60;
      const hourEnd = Math.min(i.durationMin, (h + 1) * 60);
      let hourCarbs = 0;
      // For triathlon: skip the entire hour if it's all inside the swim window
      if (i.sport === 'triathlon' && hourEnd <= swimGuardMin) {
        continue;   // no fueling possible during swim
      }

      // Place MIX at the start of the hour if cadence aligns.
      // CLINICAL: MIX90 Caf carries 100mg caffeine per bottle. We MUST enforce the
      // ISSN-derived caf cap here — falling back to the non-caf MIX if a caf bottle
      // would push total caffeine over the cap (Carla 7.69 mg/kg bug, audit S-1).
      if (h === 0 || (h % Math.round(mixSpacingHrs) === 0)) {
        let bottle = mixSku;
        if (bottle.perUnit.caffeineMg > 0
            && totalCaffeine + bottle.perUnit.caffeineMg > cafCapMg) {
          // Switch to the non-caf MIX90 (or MIX60 if that was the original choice)
          bottle = bottle === PRODUCTS.MIX90_CAF ? PRODUCTS.MIX90 : PRODUCTS.MIX60;
        }
        // Triathlon — push first MIX placement to T1 (after swim) instead of t=0
        const placeAt = (i.sport === 'triathlon' && h === 0) ? swimGuardMin : hourStart;
        if (hourCarbs + bottle.perUnit.carbsG <= gutCeiling) {
          pushEvent({
            timeMin: placeAt,
            product: bottle,
            qty: 1,
            carbs: bottle.perUnit.carbsG,
            fluid: bottle.perUnit.fluidMl,
            sodium: bottle.perUnit.sodiumMg,
            caffeine: bottle.perUnit.caffeineMg,
            label: 'Bottle',
            phase: 'in'
          });
          hourCarbs += bottle.perUnit.carbsG;
        }
      }

      // BAR slot: try to place at nextBarAtMin if it falls in this hour.
      // Cadence advances regardless of whether it fit — preserves rhythm across full session.
      if (barEnabled && nextBarAtMin >= hourStart && nextBarAtMin < hourEnd) {
        const bar = PRODUCTS.BAR50_VARIETY;
        const fits = hourCarbs + bar.perUnit.carbsG <= gutCeiling;
        const inWindow = nextBarAtMin <= i.durationMin - 30;
        if (fits && inWindow) {
          pushEvent({
            timeMin: nextBarAtMin,
            product: bar,
            qty: 1,
            carbs: bar.perUnit.carbsG,
            fluid: 0,
            sodium: bar.perUnit.sodiumMg,
            caffeine: 0,
            label: 'Bar',
            phase: 'in'
          });
          hourCarbs += bar.perUnit.carbsG;
        }
        nextBarAtMin += 90;     // always advance cadence
      }

      // Top up with gels until hourSoftTarget — never exceed gutCeiling
      let gelsThisHour = 0;
      while (gelsThisHour < 3) {
        if (hourCarbs >= hourSoftTarget) break;
        const remaining = gutCeiling - hourCarbs;
        const gel = pickGel(remaining);
        if (!gel) break;
        const slot = hourStart + Math.round((gelsThisHour + 1) * (60 / 3));
        if (slot >= hourEnd) break;
        pushEvent({
          timeMin: slot,
          product: gel,
          qty: 1,
          carbs: gel.perUnit.carbsG,
          fluid: 0,
          sodium: gel.perUnit.sodiumMg,
          caffeine: gel.perUnit.caffeineMg,
          label: 'Gel',
          phase: 'in'
        });
        hourCarbs += gel.perUnit.carbsG;
        gelsThisHour++;
      }
    }

    // ── 2. SLT+ — sodium top-up where the gap remains ──
    const sodiumNeed = sodiumTargetMgH * durHrs;
    const sodiumGap = sodiumNeed - totalSodium;
    const sltUnits = sodiumGap > 0 ? Math.ceil(sodiumGap / PRODUCTS.SLT_PLUS.perUnit.sodiumMg) : 0;
    for (let s = 0; s < sltUnits; s++) {
      const t = Math.round(((s + 0.5) * (durHrs / Math.max(1, sltUnits))) * 60);
      const slt = PRODUCTS.SLT_PLUS;
      pushEvent({
        timeMin: t,
        product: slt,
        qty: 1,
        carbs: 0,
        fluid: slt.perUnit.fluidMl,
        sodium: slt.perUnit.sodiumMg,
        caffeine: 0,
        label: 'Electrolyte',
        phase: 'in'
      });
    }

    // Sort events by time (pre-race events stay first thanks to negative timeMin)
    events.sort(function (a, b) { return a.timeMin - b.timeMin; });

    // ── 3. SAFETY NET — final per-hour ceiling enforcement ──
    // If any hour still exceeds gutCeiling (edge cases), push the latest event forward.
    let pass = 0;
    while (pass < 10) {
      let breached = false;
      for (let h = 0; h < hours; h++) {
        const hStart = h * 60, hEnd = (h + 1) * 60;
        const inHour = events.filter(function (e) { return e.timeMin >= hStart && e.timeMin < hEnd && e.carbs > 0; });
        let sum = inHour.reduce(function (s, e) { return s + e.carbs; }, 0);
        while (sum > gutCeiling && inHour.length > 1) {
          const moved = inHour.pop();
          if (hEnd + 10 > i.durationMin - 15) {
            // No room left — drop the event entirely
            const idx = events.indexOf(moved);
            if (idx >= 0) events.splice(idx, 1);
          } else {
            moved.timeMin = hEnd + 10;
          }
          sum -= moved.carbs;
          breached = true;
        }
      }
      if (!breached) break;
      events.sort(function (a, b) { return a.timeMin - b.timeMin; });
      pass++;
    }

    // Recalculate running totals after redistribution (safety net may have dropped events)
    totalCarbs = 0; totalFluid = 0; totalSodium = 0; totalCaffeine = 0;
    events.forEach(function (e) {
      totalCarbs += e.carbs || 0;
      totalFluid += e.fluid || 0;
      totalSodium += e.sodium || 0;
      totalCaffeine += e.caffeine || 0;
    });

    /* BUNDLE ─────────────────────────────────── */
    // Tally events per product, round up to full retail packs.
    const productTally = {};
    events.forEach(function (ev) {
      const k = ev.product.key;
      productTally[k] = (productTally[k] || 0) + ev.qty;
    });

    const bundle = Object.keys(productTally).map(function (key) {
      const p = PRODUCTS[key];
      const unitsNeeded = productTally[key];
      const boxes = Math.max(1, Math.ceil(unitsNeeded / p.packSize));
      const totalUnits = boxes * p.packSize;
      const sessionsCovered = +(totalUnits / unitsNeeded).toFixed(1);
      return {
        key: key,
        product: p,
        unitsNeeded: unitsNeeded,
        boxes: boxes,
        totalUnits: totalUnits,
        sessionsCovered: sessionsCovered,
        lineTotal: +(boxes * p.price).toFixed(2)
      };
    }).sort(function (a, b) {
      // Sort by family role: drink → gel → bar → electrolyte
      const order = { 'drink-base': 1, 'drink-high': 1, 'drink-high-caf': 1, 'gel-carb': 2, 'gel-caf': 2, 'bar-solid': 3, 'electrolyte': 4 };
      return (order[a.product.role] || 9) - (order[b.product.role] || 9);
    });

    const bundleTotal = +bundle.reduce(function (sum, b) { return sum + b.lineTotal; }, 0).toFixed(2);

    /* REASONING ─────────────────────────────── */
    const reasoning = [];
    reasoning.push({
      n: 1,
      claim: 'Carb target of ' + carbTargetGH + ' g/h matches your ' + gut.label.toLowerCase() + ' gut tier and ' + intensity.label.toLowerCase() + ' intensity. Higher carb rates require gut training over time.',
      cites: [1, 3]
    });
    reasoning.push({
      n: 2,
      claim: 'STYRKR\u2019s 1:0.8 maltodextrin-to-fructose ratio enables ' + (carbTargetGH >= 90 ? 'multi-carb absorption above 60 g/h' : 'efficient absorption with reduced GI distress') + ' across the GEL50 and MIX range.',
      cites: [2]
    });
    reasoning.push({
      n: 3,
      claim: 'Fluid target ' + fluidTargetMlH + ' ml/h replaces ~70% of estimated sweat losses (' + sweatRate + ' ml/h), in line with hydration-without-overdrinking guidelines.',
      cites: [4, 10]
    });
    reasoning.push({
      n: 4,
      claim: 'Sodium target ' + sodiumTargetMgH + ' mg/h reflects a ' + sodTier.label.toLowerCase() + ' sweat sodium profile. SLT+ tops up the gap that drink mix and gels alone don\u2019t close.',
      cites: [5, 10]
    });
    if (i.caffeine !== 'no') {
      reasoning.push({
        n: 5,
        claim: 'Caffeine routing keeps total dose below ' + cafCapMg + ' mg (' + (i.caffeine === 'half' ? '~4' : '~5') + ' mg/kg) — ISSN-recommended performance range, ' + (i.caffeine === 'half' ? 'alternated to avoid late-stage stimulant overload.' : 'distributed across the session.'),
        cites: [6]
      });
    }
    var hasBar = events.some(function (e) { return e.product.role === 'bar-solid'; });
    if (hasBar) {
      reasoning.push({
        n: reasoning.length + 1,
        claim: 'BAR50 added because session is over 2h and ' + sport.label + ' supports solid food — bars improve satiety and tolerance below race-pace.',
        cites: [8]
      });
    }
    if (isRace) {
      reasoning.push({
        n: reasoning.length + 1,
        claim: 'A pre-race GEL50 is scheduled 30 min before the gun to top up liver glycogen and stabilise blood glucose at the start.',
        cites: [7]
      });
    }

    /* CHART DATA ─────────────────────────────── */
    // Sampled every 5 min. Adds: intake vs oxidation, glycogen %, caffeine plasma,
    // hydration % loss, W'bal, bonk risk index.
    const chartTicks = [];

    // Fluid intake is sipped over the time the bottle is in use, not chugged at
    // the placement moment. Build per-bottle consumption windows so the hydration
    // chart reflects realistic gradual intake rather than instant delivery.
    const fluidEvents = events
      .filter(function (ev) { return ev.fluid > 0; })
      .map(function (ev) { return { timeMin: ev.timeMin, fluid: ev.fluid }; })
      .sort(function (a, b) { return a.timeMin - b.timeMin; });
    fluidEvents.forEach(function (ev, idx) {
      var next = fluidEvents[idx + 1];
      ev.windowMin = Math.max(1, (next ? next.timeMin : i.durationMin + 15) - ev.timeMin);
    });
    // Caffeine pharmacokinetic constants
    const cafHalfLifeMin = 5 * 60;            // ~5h plasma half-life
    const cafKe = Math.log(2) / cafHalfLifeMin; // elimination rate constant
    // Glycogen reserve estimate (g): ~12 g/kg for trained endurance athletes
    const glycogenStartG = 12 * i.weightKg;
    // Burn rate per minute at this intensity (approx kcal/min, then to glucose-equivalent g)
    // 75kg cyclist at steady = ~750 kcal/h → ~187 g glucose-equivalent/h (4 kcal/g) but only ~50-60% from CHO
    // Simplified: muscleGlycogenBurnRate (g/h) = intensity-driven, modulated by exogenous carb intake
    const baseGlycogenBurnGH = (carbTargetGH * 1.6) * intensity.carbMult;

    // ── W'bal model (cyclists/triathlon/MTB only) ──
    // Skiba 2012 simplified for planning view. W'₀ = anaerobic work capacity (kJ).
    // Skiba's regression on trained cyclists: W' typically 15–25 kJ, weak FTP correlation.
    // Banded by FTP tier so the number is honest rather than precise.
    const isCyclistish = ['road_cycle', 'offroad_cyc', 'triathlon'].indexOf(i.sport) >= 0;
    const wbalInitialKJ = (function () {
      if (!i.ftpW) return 20;                 // unknown FTP → trained athlete default
      if (i.ftpW >= 350) return 25;           // elite
      if (i.ftpW >= 280) return 22;           // strong amateur
      if (i.ftpW >= 220) return 19;           // trained recreational
      return 16;                              // beginner / lighter rider
    })();
    // Drain rate as fraction of W'₀ per hour at the planned intensity:
    // easy/steady stay below CP → no drain. Threshold sits at CP. Race-pace above CP.
    const wbalDrainPerHr = (
      i.intensity === 'race'      ? 0.20 :
      i.intensity === 'threshold' ? 0.10 :
      0.0
    );
    // Body mass in grams for hydration calc
    const bodyMassG = i.weightKg * 1000;
    // Respiratory water loss (~50 g/h, exhaled humidity)
    const respLossGH = 50;

    for (let t = preStartMin; t <= i.durationMin; t += 5) {
      let cumCarbsIntake = 0, cumSodium = 0, cumCaf = 0;
      events.forEach(function (ev) {
        if (ev.timeMin <= t) {
          cumCarbsIntake += ev.carbs;
          cumSodium += ev.sodium;
          cumCaf += ev.caffeine;
        }
      });
      // Fluid is distributed over each bottle's window — partial credit before window ends.
      let cumFluid = 0;
      fluidEvents.forEach(function (fe) {
        if (fe.timeMin > t) return;
        const elapsed = t - fe.timeMin;
        const fraction = Math.min(1, Math.max(0, elapsed / fe.windowMin));
        cumFluid += fe.fluid * fraction;
      });
      cumFluid = Math.round(cumFluid);

      // Oxidation only starts at t=0 (race start). Pre-race carbs sit in liver/gut.
      const tEffortMin = Math.max(0, t);
      const tHrs = tEffortMin / 60;
      const cumOxidationCap = carbTargetGH * tHrs;
      const cumOxidation = Math.min(cumCarbsIntake, cumOxidationCap);
      const inSystemCarbs = Math.max(0, cumCarbsIntake - cumOxidation);

      // Glycogen depletion only starts at t=0
      const glycogenSpent = (baseGlycogenBurnGH * tHrs) - cumOxidation;
      const glycogenRemainingPct = Math.max(0, Math.min(100, 100 * (1 - Math.max(0, glycogenSpent) / glycogenStartG)));

      // Caffeine plasma: sum of (dose × decay since dose)
      let cafPlasma = 0;
      events.forEach(function (ev) {
        if (ev.caffeine > 0 && ev.timeMin <= t) {
          const dt = t - ev.timeMin;
          cafPlasma += ev.caffeine * Math.exp(-cafKe * dt);
        }
      });
      const cafPerKg = cafPlasma / i.weightKg;

      // Estimated losses (only after race start; pre-race window doesn't sweat)
      const lossFluid = (sweatRate / 60) * tEffortMin;
      const lossSodium = ((sweatRate / 1000) * sodTier.mgPerL / 60) * tEffortMin;
      // Estimated effort curve (relative power/pace as % of threshold)
      const effort = intensity.effortPct + (Math.sin(t / 30) * 3);

      // ── Hydration % body-mass loss ──
      // sweat + respiratory loss minus fluid intake, expressed as % of starting body mass.
      const hydrationLossG = lossFluid + respLossGH * tHrs - cumFluid;
      const hydrationLossPct = Math.max(0, 100 * hydrationLossG / bodyMassG);

      // ── W' balance (cyclistish only) ──
      // Fueling adequacy reduces drain by up to 50% — well-fueled riders defend W'.
      let wbalPct = 100;
      if (isCyclistish && tEffortMin > 0) {
        const target_so_far = carbTargetGH * tHrs;
        const fuelingEfficacy = Math.min(1, cumOxidation / Math.max(1, target_so_far));
        const wbalDrainFrac = wbalDrainPerHr * tHrs * (1 - fuelingEfficacy * 0.5);
        wbalPct = Math.max(0, Math.min(100, 100 * (1 - wbalDrainFrac)));
      }

      // ── Bonk Risk Index (composite) ──
      // 0–100. Weights: 40% glycogen depletion, 30% carb-intake gap, 20% intensity, 10% hydration.
      const carbGapFrac = tEffortMin > 0
        ? Math.max(0, (carbTargetGH * tHrs - cumCarbsIntake) / Math.max(1, carbTargetGH * tHrs))
        : 0;
      const intensityFactor = Math.max(0, intensity.carbMult - 1);
      const hydrationPenalty = Math.max(0, hydrationLossPct - 2) / 4;
      const bonkRisk = (
        0.40 * (1 - glycogenRemainingPct / 100) +
        0.30 * carbGapFrac +
        0.20 * intensityFactor +
        0.10 * hydrationPenalty
      );
      const bonkRiskPct = Math.max(0, Math.min(100, Math.round(bonkRisk * 100)));

      chartTicks.push({
        timeMin: t,
        cumCarbsIntake: cumCarbsIntake,
        cumOxidation: Math.round(cumOxidation),
        inSystemCarbs: Math.round(inSystemCarbs),
        cumFluid: cumFluid,
        cumSodium: cumSodium,
        cumCaf: Math.round(cafPlasma),
        cafPerKg: +cafPerKg.toFixed(2),
        glycogenPct: Math.round(glycogenRemainingPct),
        lossFluid: Math.round(lossFluid),
        lossSodium: Math.round(lossSodium),
        effortPct: Math.round(effort * 10) / 10,
        // New advanced models
        wbalPct: +wbalPct.toFixed(1),
        hydrationLossPct: +hydrationLossPct.toFixed(2),
        bonkRiskPct: bonkRiskPct,
        // Legacy alias for backwards compat
        cumCarbs: cumCarbsIntake
      });
    }

    // Per-hour carb rate (with optional PRE bucket for race mode)
    const hourlyCarbs = [];
    if (isRace) {
      let preCarbs = 0;
      events.forEach(function (ev) { if (ev.timeMin < 0) preCarbs += ev.carbs || 0; });
      hourlyCarbs.push({ hour: 'PRE', label: 'Pre', carbs: preCarbs, isPre: true });
    }
    for (let h = 0; h < hours; h++) {
      let inHour = 0;
      events.forEach(function (ev) {
        if (ev.timeMin >= h * 60 && ev.timeMin < (h + 1) * 60) {
          inHour += ev.carbs;
        }
      });
      hourlyCarbs.push({ hour: h + 1, label: 'H' + (h + 1), carbs: inHour, isPre: false });
    }

    /* RETURN ─────────────────────────────────── */
    return {
      input: i,
      targets: {
        carbsGH: carbTargetGH,
        fluidMlH: fluidTargetMlH,
        sodiumMgH: sodiumTargetMgH,
        cafCapMg: cafCapMg,
        sweatRate: sweatRate,
        durationMin: i.durationMin,
        gutCeilingGH: gut.target,
        preStartMin: preStartMin,
        isRace: isRace
      },
      totals: {
        carbsG: totalCarbs,
        fluidMl: totalFluid,
        sodiumMg: totalSodium,
        caffeineMg: totalCaffeine
      },
      events: events,
      bundle: bundle,
      bundleTotal: bundleTotal,
      reasoning: reasoning,
      chart: { ticks: chartTicks, hourlyCarbs: hourlyCarbs },
      meta: {
        isCyclistish: isCyclistish,
        wbalInitialKJ: +wbalInitialKJ.toFixed(1),
        bodyMassG: bodyMassG
      },
      planId: 'STYRKR-FP-' + new Date().getFullYear() + '-' + Math.random().toString(36).substring(2, 8).toUpperCase()
    };
  }

  /* ─────────────────────────────────────────────
     EXPORT
  ───────────────────────────────────────────── */
  window.STYRKR_FUEL_DATA = {
    CITATIONS: CITATIONS,
    PRODUCTS: PRODUCTS,
    DISCIPLINES: DISCIPLINES,
    INTENSITY: INTENSITY,
    GUT_TIERS: GUT_TIERS,
    SODIUM_TIERS: SODIUM_TIERS,
    generatePlan: generatePlan,
    version: '1.0.0'
  };

})(window);
